module.exports = __webpack_public_path__ + "img/primary.13c5468.svg";